import Vue from 'vue';

export default Vue.filter('priceFormat', value => {
        if (!value) return '';
        if (value.toString().split(".").length === 2) {
            value = Number(value).toFixed(2);
        }
        return value
    }
);


// WEBPACK FOOTER //
// ./src/filters/priceFormat.js